/**
 * Roda `callback` depois do `load` da página e de um momento ocioso do navegador.
 * Usado para scripts de gravação (PostHog, Contentsquare) não disputarem rede e CPU
 * com o primeiro paint das landings. Chamadas repetidas antes do load rodam uma vez cada.
 */
export function afterPageLoad(callback, { idleTimeout = 3000 } = {}) {
  if (typeof window === 'undefined') return;

  const runWhenIdle = () => {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(() => callback(), { timeout: idleTimeout });
    } else {
      window.setTimeout(callback, 1);
    }
  };

  if (document.readyState === 'complete') {
    runWhenIdle();
  } else {
    window.addEventListener('load', runWhenIdle, { once: true });
  }
}
